import { SERVICE } from './constants'

export const FETCH_SEARCHES = `${SERVICE}/FETCH_SEARCHES`
export const SEARCHES_ERROR = `${SERVICE}/SEARCHES_ERROR`
export const SEARCHES_SUCCESS = `${SERVICE}/SEARCHES_SUCCESS`

export const SET_SEARCHES = `${SERVICE}/SET_SEARCHES`
export const CLEAR_SEARCHES = `${SERVICE}/CLEAR_SEARCHES`

export const FAKE_REMOVE = `${SERVICE}/FAKE_REMOVE`

export const REMOVE = `${SERVICE}/REMOVE`
export const REMOVE_ERROR = `${SERVICE}/REMOVE_ERROR`
export const REMOVE_SUCCESS = `${SERVICE}/REMOVE_SUCCESS`

export const FETCH_SEARCH_DETAILS = `${SERVICE}/FETCH_SEARCH_DETAILS`
export const SEARCH_DETAILS_ERROR = `${SERVICE}/SEARCH_DETAILS_ERROR`
export const SEARCH_DETAILS_SUCCESS = `${SERVICE}/SEARCH_DETAILS_SUCCESS`

export const SET_SEARCH_DETAILS_FILTERS = `${SERVICE}/SET_SEARCH_DETAILS_FILTERS`
export const CLEAR_SEARCH_DETAILS_FILTERS = `${SERVICE}/CLEAR_SEARCH_DETAILS_FILTERS`

export const SET_SEARCH_DETAILS_RESULTS = `${SERVICE}/SET_SEARCH_DETAILS_RESULTS`
export const MERGE_SEARCH_DETAILS_RESULTS = `${SERVICE}/MERGE_SEARCH_DETAILS_RESULTS`
export const CLEAR_SEARCH_DETAILS_RESULTS = `${SERVICE}/CLEAR_SEARCH_DETAILS_RESULTS`

export const GET_SEARCH_OPTIONS = `${SERVICE}/GET_SEARCH_OPTIONS`
export const SET_SEARCH_OPTIONS = `${SERVICE}/SET_SEARCH_OPTIONS`
export const CLEAR_SEARCH_OPTIONS = `${SERVICE}/CLEAR_SEARCH_OPTIONS`

export const SET_SEARCH_TO_SAVE = `${SERVICE}/SET_SEARCH_TO_SAVE`
export const CLEAR_SEARCH_TO_SAVE = `${SERVICE}/CLEAR_SEARCH_TO_SAVE`

export const SAVE = `${SERVICE}/SAVE`
export const SAVE_ERROR = `${SERVICE}/SAVE_ERROR`
export const SAVE_SUCCESS = `${SERVICE}/SAVE_SUCCESS`

export const FAKE_ADD_VENDOR = `${SERVICE}/FAKE_ADD_VENDOR`
export const ADD_VENDOR = `${SERVICE}/ADD_VENDOR`
export const ADD_VENDOR_ERROR = `${SERVICE}/ADD_VENDOR_ERROR`
export const ADD_VENDOR_SUCCESS = `${SERVICE}/ADD_VENDOR_SUCCESS`

export const EXPORT = `${SERVICE}/EXPORT`
export const EXPORT_ERROR = `${SERVICE}/EXPORT_ERROR`
export const EXPORT_SUCCESS = `${SERVICE}/EXPORT_SUCCESS`
